<template>
  <div class="card_offer">
    <img
      class="card_offer__image"
      v-if="offer.images[1]"
      :src="getImageServer() + offer.images[1].attributes.image.url"
    >
    <img
      class="card_offer__image"
      v-else
      :src="getImageServer() + offer.images[0].attributes.image.url"
    >

    <div class="card_offer__actions">
      <v-layout row wrap fill-height>
        <v-flex xs8>
          <div class="actions_date">
            <img src="@/assets/img/icons/available-icon.svg" />
            <div class="actions_date__text">
              <div>Disponible hasta</div>
              <div class="actions_date__date">{{offer.attributes.expiration}}</div>
            </div>
          </div>
        </v-flex>
        <v-flex xs4 class="actions_buttons">
            <button
              class="actions_buttons__delete"
              @mouseover="hover.delete = true"
              @mouseleave="hover.delete = false"
              :style="{backgroundColor: hover.delete ? '#FC243B' : '#DFE4ED'}"
            >
              <delete-icon
                :color="hover.delete ? '#FFFFFF' : '#5a6b8e'"
                width="35"
                height="35"
              ></delete-icon>
            </button>
            <button
              class="actions_buttons__edit"
              @click="$router.push({name: 'offer_edit', params: {id: offer.id}})"
              @mouseover="hover.edit = true"
              @mouseleave="hover.edit = false"
              :style="{backgroundColor: hover.edit ? '#1476FB' : '#DFE4ED'}"
            >
              <edit-icon
                :color="hover.edit ? '#FFFFFF' : '#5a6b8e'"
                width="35"
                height="35"
              ></edit-icon>
            </button>
            <div class="actions_small_desktop">
              <v-menu bottom left >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  v-on="on"
                  style="margin-right: -8px"
                >
                  <v-icon color="#5a6b8e">more_vert</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-tile
                  @click="$router.push({name: 'offer_edit', params: {id: offer.id}})"
                >
                  <edit-icon
                    :color="hover.edit ? '#FFFFFF' : '#5a6b8e'"
                    width="35"
                    height="35"
                  ></edit-icon>
                  <v-list-tile-title class="ml-2" style="color: #5a6b8e"> Editar</v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                >
                  <delete-icon
                    :color="hover.delete ? '#FFFFFF' : '#5a6b8e'"
                    width="35"
                    height="35"
                  ></delete-icon>
                  <v-list-tile-title class="ml-2" style="color: #5a6b8e">Eliminar</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            </div>

        </v-flex>
      </v-layout>
    </div>
    <div class="card_offer__body">
      <div class="card_offer__body--title">
        {{offer.attributes.title | capitalize}}
      </div>

      <div class="card_offer__body--subtitle">
        Descripción
      </div>
      <p class="card_offer__body--text">{{offer.attributes.description}}</p>

      <div class="card_offer__body--subtitle">
        Términos y condiciones
      </div>
      <p class="card_offer__body--text">{{offer.attributes.tc }}</p>

      <v-flex lg12 class="canjes">
        <v-flex lg6 class="canjes__item mr-2">
          <p class="canjes__item--code">Códigos</p>
          <p class="canjes__item--title">Disponibles</p>
          <button class="canjes__item--button">
            {{offer.attributes.redeem_limit >= 0 ? formatPrice(offer.attributes.redeem_limit) : 'Sin limite'}}
          </button>
        </v-flex>
        <v-flex lg6 class="canjes__item ml-2">
          <p class="canjes__item--code">Códigos</p>
          <p class="canjes__item--title">Canjeados</p>
          <button class="canjes__item--button">
            {{Number(offer.attributes.redeem_count) > 0 ? formatPrice(offer.attributes.redeem_count) : 'Sin canjes'}}
          </button>
        </v-flex>
    </v-flex>

    </div>
  </div>
</template>
<script>
import EditIcon from './icons/EditIcon.vue'
export default {
  components: { EditIcon },
  props: {
    offer: Object
  },
  data(){
    return {
      hover: {
        edit: false,
        delete: false
      }
    }
  },
  methods:{
    formatPrice(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/OfferItem.vue